import type { FC } from 'react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { isLocalStorageSupported } from 'src/hooks/use-storage';

export const CookieCheck: FC = () => {
  useEffect(() => {
    if (isLocalStorageSupported) return;
    toast.error(
      "The local storage can't be used. You will not be able to fully use the platform without this. This can happen for example, if all cookies are blocked."
    );
  }, []);

  return null;
};
